module.exports = __webpack_public_path__ + "static/fitch-0e335afd705380b392129f0cb221ced1.jpg";